<style scoped>
#container {
	background: #e4e9f0;
	max-width: 1600px;
	min-width: 1400px;
	display: flex;
	flex-direction: column;
	margin: auto;
	height: 100%;
	position: relative;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

	/* background: url(../assets/content_bj.png);
	background-size: 100% 100%; */
}
.top {
	display: flex;
	/* height: 760px; */
	/* height: 100%; */
}
.top1 {
	height: 760px;
}
.top2 {
	height: 100%;
}
.bottom {
	padding: 20px 60px 55px 40px;
	flex-grow: 1;
	overflow: hidden;
}
.left {
	width: calc(63% - 60px);
	min-width: 830px;
	padding: 20px 30px 55px 40px;
}
.right {
	flex-grow: 1;
	/* width:37%; */
	/* padding: 50px; */
	padding: 20px 60px 55px 0px;
	/* background: #fff; */
}
.title {
	font-size: 20px;
	font-family: PingFang SC;
	font-weight: 500;
	color: #1a1a1a;
}
.select_factory_box {
	margin-top: 17px;
	padding: 24px;
	background: #fff;
	border-radius: 8px;
	height: calc(100% - 48px);
}
.content_box {
	margin-top: 17px;
	padding: 24px;
	background: #fff;
	border-radius: 8px;
	height: calc(100% - 48px);
}
.fiter {
	
	padding-bottom: 8px;
}
.reset_search {
	width: 120px;
	float: right;
}
.chuansuo {
	margin-top: 12px;
	/* height: 550px; */
	height: calc(100% - 100px);
}

.send_box {
	margin-top: 50px;
	text-align: center;
}
.title1 {
	color: #666;
	font-size: 16px;
	/* margin-top: 40px; */
}
.notice_history {
	/* margin-top: 17px; */
	padding: 24px;
	background: #fff;
	border-radius: 8px;
	/* height: calc(100% - 48px); */
	height: calc(100% - 15px);
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-content: flex-start;
	overflow: hidden;
	overflow-y: auto;
}
.notice_item {
	width: calc(33.33% - 35px);
	height: 104px;
	background: #f2f6fa;
	border-radius: 10px;
	border-left: 4px solid #2b5bda;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	padding: 0 10px;
	cursor: pointer;
	margin-bottom: 16px;
}
.pop_notice_item {
	/* height: 125px; */
	line-height: 30px;
	background: #f2f6fa;
	border-radius: 10px;
	border-left: 4px solid #2b5bda;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	padding: 10px;
	cursor: pointer;
	margin-bottom: 16px;
}
.pop_check_item {
	background: #f2f6fa;
	border-radius: 10px;
	border-left: 4px solid #2b5bda;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	padding: 10px 10px;
	/* cursor: pointer; */
	margin-bottom: 16px;
	line-height: 22px;
	position: relative;
	overflow: hidden;
}

.title2 {
	font-size: 16px;
	font-family: PingFang SC;
	font-weight: 500;
	color: #1a1a1a;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.send_time {
	font-size: 12px;
	font-family: PingFang SC;
	font-weight: 400;
	color: #666666;
}
.send_info {
	display: flex;
	justify-content: space-between;
}
.send_user {
	font-size: 14px;
	font-family: PingFang SC;
	font-weight: 400;
	color: #333;
}
.send_num {
	color: #03a9f4;
	font-size: 14px;
}
.success_num {
	font-size: 14px;
	margin-left: 20px;
	color: #4caf50;
}
.fail_num{
	font-size: 14px;
	margin-left: 20px;
	color: #f56c6c;
	cursor: pointer;
}
.reply_num{
	font-size: 14px;
	color: #e6a23c;
}
.reply_num.active{
	color: #ffffff;
    background: #67c23a;
    border-radius: 6px;
}
.notice_reply_number>.reply_num{
	cursor: pointer;
	padding: 4px 5px;
}
.title3 {
	font-size: 22px;
	font-family: PingFang SC;
	font-weight: 500;
	color: #1a1a1a;
	line-height: 32px;
}
.send_time2 {
	font-size: 14px;
	font-family: PingFang SC;
	font-weight: 400;
	color: #999999;
	line-height: 24px;
	display: flex;
	justify-content: space-between;
	margin-top: 10px;
}
.notice_content {
	font-size: 18px;
	font-family: PingFang SC;
	font-weight: 400;
	color: #333333;
	line-height: 32px;
	margin-top: 20px;
}
.send_status {
	display: flex;
	justify-content: flex-end;
	margin-top: 24px;
}
.file {
	padding: 0 12px;
	min-height: 40px;
	background: #e3edfc;
	border-radius: 4px;
	font-size: 16px;
	font-family: PingFang SC;
	font-weight: 400;
	color: #2074fe;
	line-height: 24px;
	line-height: 40px;
	margin-top: 24px;
	width: fit-content;
	cursor: pointer;
}
.fenge {
	margin-top: 24px;
	height: 8px;
	background: #f2f6fa;
}
.factory_name {
	height: 32px;
	background: #f2f6fa;
	border-radius: 4px;
	line-height: 32px;
	font-size: 16px;
	font-family: PingFang SC;
	font-weight: 400;
	color: #1a1a1a;
	padding: 0 12px;
	margin-right: 12px;
	margin-bottom: 12px;
}
.factory_box {
	margin-top: 12px;
	display: flex;
	flex-wrap: wrap;
	max-height: 280px;
	overflow: hidden;
	overflow-y: auto;
}
.hidden {
	opacity: 0;
	cursor: default;
}
.again_box {
	text-align: center;
	margin-top: 20px;
}
.right_float {
	position: absolute;
	right: 0;
	top: 0;
	bottom: 0;
	margin: auto;
	height: 220px;
	text-align: center;
	font-size: 15px;
	display: flex;
	flex-direction: column;
	/* justify-content: space-between; */
	justify-content: center;
}
.right_float > div:hover {
	box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);
}
.show_record {
	width: 28px;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #f2f2f2;
	border-radius: 10px 0 0 10px;
	cursor: pointer;
	font-size: 15px;
	box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
	color: #3f9eff;
	padding: 10px 5px;
	margin-bottom: 10px;
}
.check_self {
	width: 28px;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #f2f2f2;
	border-radius: 10px 0 0 10px;
	cursor: pointer;
	font-size: 15px;
	box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
	color: #3f9eff;
	padding: 10px 5px;
	margin-bottom: 10px;
}
.check_history {
	width: 28px;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #f2f2f2;
	border-radius: 10px 0 0 10px;
	cursor: pointer;
	font-size: 15px;
	box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
	color: #3f9eff;
	padding: 10px 5px;
	margin-bottom: 10px;
}
.rectification {
	width: 28px;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #f2f2f2;
	border-radius: 10px 0 0 10px;
	cursor: pointer;
	font-size: 15px;
	box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
	color: #3f9eff;
	padding: 10px 5px;
}
.styles {
	position: absolute;
	right: 10px;
	top: 10px;
	display: flex;
}
.styles > div {
	margin-right: 10px;
	background: #fff;
	padding: 4px 10px;
	font-size: 14px;
	border-radius: 6px;
	cursor: pointer;
}

.styles > .active {
	background: #03a9f4;
	color: #fff;
	transform: 300ms;
}
.record_box >>> .el-drawer {
	min-width: 410px !important;
}

.img_box {
	display: flex;
	flex-wrap: wrap;
	margin-top: 10px;
}
.img_item {
	width: 100px;
	height: 100px;
	overflow: hidden;
	margin-right: 10px;
	margin-bottom: 10px;
	position: relative;
	background: rgba(0, 0, 0, 0.2);
}
.img_item > img {
	width: 100%;
	height: 100%;
	/* position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	margin: auto; */
	object-fit: cover;
}
.no_data {
	text-align: center;
	font-size: 16px;
	color: #999;
	margin-top: 20px;
}
.no_data > img {
	margin-top: 30%;
	width: 150px;
	height: 150px;
}
.change_style {
	width: 30px;
	height: 30px;
	cursor: pointer;
	transition: 300ms;
}

.checked {
	background: #ff5722;
	color: #fff;
	width: 100px;
	height: 24px;
	line-height: 24px;
	text-align: center;
	position: absolute;
	right: -48px;
	top: -40px;
	transform-origin: left;
	transform: rotate(45deg);
	font-size: 12px;
	padding-top: 15px;
}
.checked1 {
	background: #ff5722;
}
.checked2 {
	background: #ff9800;
}
.checked3 {
	background: #4caf50;
}
.unit_name{
	text-align: center;
	color: #333;
	border-bottom: 4px solid #2b5bda;
	border-radius:  0 0 10px;
}
.have_problem{
    font-size: 14px;
    color: rgb(238, 41, 41);
}
.no_problem{
    font-size: 14px;
    color: #009688;
}
.red{
    color: #D8241B;
}
.green{
    color: #009688;
}
.yellow{
    color: #fabc38;
}
.border{
    padding: 4px 0;

	display: flex;
    align-items: center;
    justify-content: space-between;
}
.border1{
	display: block;
	padding: 4px 0;
}
.border:not(:last-child){
    border-bottom: 1px dashed #fbb5a0;
}
.text{
    font-size: 12px;color: #999;
	width: 100px;
	display: block;
}
.value{
    color: #333;
    font-size: 13px;
	max-width: calc(100% - 100px);
    /* margin-top: 6px; */
}
pre{
	margin: 0;
	font-weight: 500;
	white-space: pre-wrap;
  	word-wrap: break-word;
}
.top_bar{
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f2f2f2;
    padding: 5px 0;
    line-height: 22px;
    border-bottom: 3px solid #009688;
    border-radius: 5px;
}
.center{
    /* padding-top: 20px; */
    text-align: center;
    font-size: 14px;
    color: #333;
}
.pla_txt{
    color: #999;
}
.block{
    padding: 20px 0;
}
.resolution{
    text-align: right;
}
.block{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #333;
    padding: 12px 0;
	border-bottom: 1px dashed #fbb5a0;
}
/* .block:not(:last-child){
    border-bottom: 1px dashed #fbb5a0;
} */
.resolution_btn{
    background: #2469C8;
    height: 44px;
    border-radius: 6px;
    text-align: center;
    line-height: 44px;
    color: #fff;
    font-size: 16px;
    margin-top: 20px;
	cursor: pointer;
}
.resolution_btn:hover{
	background: #1a4f9b;
}
.push_box{
	border-bottom: 1px dashed #fbb5a0;
}
.push_number{
	display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #333;
	border-bottom: 1px dashed #fbb5a0;
}
.push_item{
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 12px;
	color: #333;
	margin: 4px;
}
.push_item:not(:last-child){
	border-bottom: 1px dashed #999;
}
.push_btn{
	display: flex;
	padding: 10px;
	justify-content: space-evenly;
}
.push_btn>div{
	width: 130px;
	cursor: pointer;
}
.notice_info_box{
	width:620px;
	padding: 0px 20px;
	display: flex;
    flex-direction: column;
	overflow-y: auto;
}
.notice_send_status{
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 14px;
	color: #333;
}
.notice_reply_number{
	display: flex;flex-direction: row;justify-content: space-between;margin-top:15px;padding: 0 3px;
}
.notice_factory_list_box{
	/* flex-grow: 1; */
	overflow: hidden;
	overflow-y: auto;
	margin-top: 12px;
	height: 448px;
	min-height: 448px;
}
.notice_factory_list{
	flex-flow: column nowrap;
    height: 100%;
    max-height: 100%;
    display: flex;
}
.notice_reply_box{
	width:470px;
	height: calc(100% - 10px);
	overflow: hidden;
	position: relative;
	display: flex;
	flex-direction: column;
	border-left: 10px solid #f2f6fa;
	padding: 0 20px 10px 20px;
}
.notice_reply_examine_info{
	padding:10px;background: #fff;box-shadow: 0 0px 8px 0px #e8e8e8;border-radius: 8px;
}
.notice_reply_examine_info .block{
	padding: 8px 0;
}
.factory_item{
    height: 88px;
    background: #f2f6fa;
    border-radius: 10px;
    border-left: 4px solid #2b5bda;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: space-evenly;
    -ms-flex-pack: space-evenly;
    justify-content: space-evenly;
    padding: 10px 10px;
    cursor: pointer;
    margin-bottom: 16px;
}
.factory_item .factory_unit_name{
	font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #1a1a1a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.factory_item .factory_address{
	font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
}
.factory_item .problem_num{
	/* color: #03a9f4; */
	color: #f56c6c;
    font-size: 14px;
	text-align: right;
}
.factory_item .problem_num.is_problem{
	/* color: #D8241B; */
	color: #67c23a;
}
.notice_reply_status{
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-right: 0;
	cursor: pointer;
    line-height: 20px;
    padding: 6px 10px;
	background: #f2f6fa;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 12px;
}
.notice_factory_active{
	background: #67c23a;
    color: #fff;
}
.notice_factory_active .send_time{
	color: #fff;
}
.notice_factory_active>div:last-child span{
	color: #fff;
}
.factory_reply_item{
	background: #f2f2f2;
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 10px;
}
.reply_item_title{
	text-align: center;
    font-size: 16px;
    color: #333;
}
.confirm_over{
	margin: auto;
    width: fit-content;
    padding: 0px 16px;
    background: #303133;
    height: 44px;
    border-radius: 6px;
    text-align: center;
    line-height: 44px;
    color: #fff;
    font-size: 16px;
    margin-top: 10px;
    cursor: pointer;
}
.confirm_over:hover{
	background: #606266;
}
.el-dialog-div{
	max-height: calc(80vh - 154px);
  	overflow-x: hidden;
}
</style>
<template>
	<div id="container">
		<div class="styles">
			<div @click="change_style(1)" :class="{ active: style == 1 }">风格1</div>
			<div @click="change_style(2)" :class="{ active: style == 2 }">风格2</div>
			<img class="change_style" :src="'/static/' + mode + '.png'" alt="" @click="change_mode()" />
		</div>
		<div class="top" :class="'top' + style">
			<div class="left">
				<div class="title">选择企业</div>
				<div class="select_factory_box">
					<div class="fiter">
						<el-select v-model="set_region" placeholder="选择区域" @change="change_condition()">
							<el-option v-for="item in region_arr" :key="item" :label="item" :value="item"> </el-option>
						</el-select>
						<el-select v-model="set_class" placeholder="选择分类" @change="change_condition()" style="margin-left:24px;">
							<el-option v-for="item in class_arr" :key="item" :label="item" :value="item"> </el-option>
						</el-select>
						<el-select v-model="set_new_energy" placeholder="新能源" @change="change_condition()" style="margin-left:24px;">
							<el-option v-for="item in new_energy" :key="item" :label="item" :value="item"> </el-option>
						</el-select>
						<el-button type="primary" class="reset_search" @click="reset_search()">重置</el-button>
					</div>
					<div style="border-bottom: 1px solid #f2f6fa;padding-bottom:10px;margin-top: 10px;">
						<el-checkbox-group v-model="check_arr" @change="change_condition()" style="display: flex;justify-content: space-between;">
							<el-checkbox v-for="item in conditions" :key="item" :label="item" :name="item">{{ item }}</el-checkbox>
						</el-checkbox-group>
					</div>
					<div class="chuansuo">
						<el-transfer
							ref="roleTransfer"
							:filterable="true"
							filter-placeholder="请输入企业名称"
							v-model="set_factory"
							:titles="['待选择', '已选择']"
							:props="{
								key: 'id',
								label: 'unit_name',
								disabled: 'disabled',
							}"
							:data="factory"
						>
						</el-transfer>
					</div>
				</div>
			</div>
			<div class="right">
				<div class="title">通知内容</div>
				<div class="content_box">
					<div>
						<p class="title1">通知类型</p>
						<el-select v-model="notice_type" placeholder="请选择">
							<el-option
							v-for="item in notice_type_arr"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</div>
					<div>
						<p class="title1">输入标题</p>
						<el-input v-model="title" placeholder="请输入标题"></el-input>
					</div>
					<div>
						<p class="title1">输入正文</p>
						<el-input type="textarea" v-model="content" placeholder="请输入正文" :autosize="{ minRows: 6, maxRows: 6 }"></el-input>
					</div>
					<div>
						<p class="title1">上传文件</p>
						<el-upload class="upload-demo" action="" ref="upload" :http-request="send_notice" :limit="2" :multiple="false" :file-list="fileList" :on-change="handleFileChange" :auto-upload="false">
							<el-button slot="trigger" type="primary">选取文件</el-button>
							<div slot="tip" class="el-upload__tip">请选择JPG、PNG、Doc、Excel、PDF</div>
						</el-upload>
					</div>
					<div class="send_box">
						<el-button style="width:160px;" type="primary" @click="submitUpload">发送</el-button>
					</div>
				</div>
			</div>
		</div>
		<div class="bottom" v-if="style == 1">
			<!-- <div class="title">通知记录</div> -->
			<div class="notice_history">
				<div class="notice_item" v-for="(item, index) in history" :key="index" @click="show_info(item)">
					<div class="title2">{{ item.title }}</div>
					<div class="send_time">{{ item.date }}</div>
					<div class="send_user">通知类型：{{ item.type==1?'仅通知':'任务整改' }}</div>
					<div class="send_info">
						<div class="send_user">发送人：{{ item.sender }}</div>
						<div>
							<span class="send_num">发送：{{ item.send_num }}家</span>
							<span class="success_num">成功：{{ item.success_num }}家</span>
						</div>
					</div>
				</div>
				<div class="notice_item hidden" v-if="history.length % 3 == 2"></div>
			</div>
		</div>

		<div class="right_float">
			<div class="show_record" @click="show_record()" v-if="style == 2">通知记录</div>
			<div class="check_self" @click="show_access_reocrd()">排查整改</div>
			<div class="check_self" @click="show_notice()">任务整改</div>
			<!-- <div class="check_self" @click="show_check_self()">自排自查</div> -->
			<!-- <div class="check_history" @click="show_check_history()">自查历史</div> -->
			<div class="rectification" @click="show_rectification()">行政整改通知书</div>
		</div>

		<!-- 任务整改右侧弹窗 -->
		<el-drawer title="任务整改" :visible.sync="is_show_notice" direction="rtl" class="record_box">
			<div style="padding: 0 24px;min-width:390px;">
				<div class="pop_notice_item" v-for="(item, index) in notice_zg" :key="index" @click="show_notice_info(item)">
					<div class="title2">{{ item.title }}</div>
					<div class="send_time">通知时间：{{ item.date }}</div>
					<div class="send_user">通知类型：{{ item.type==1?'仅通知':'自排自查' }}</div>
					<div class="send_user">发送人：{{ item.sender }}</div>
					<div class="send_user">发送状态：
						<span class="send_num">通知：{{ item.send_num }}家</span>
						<span class="success_num">成功：{{ item.success_num }}家</span>
						<span class="reply_num" style="margin-left:20px;">整改完成：{{ item.reply_success_num?item.reply_success_num:0 }}家</span>
					</div>
				</div>
			</div>
		</el-drawer>

		<!-- 任务整改审核弹窗 -->
		<el-dialog title="任务整改审核" :visible.sync="notice_zg_dialogVisible" :width="is_show_reply_info?'1140px':'640px'" height="90vh" top="5vh" :destroy-on-close="true" :before-close="close_notice_zg">
			<div style="display:flex;height: calc(90vh - 56px);overflow: hidden;">
				<div class="notice_info_box">
					<div class="notice_item_info">
						<div class="title3">{{ notice_zg_item.title }}</div>
						<div class="send_time2">
							<span>发送于：{{ notice_zg_item.date }}</span>
							<span>{{ notice_zg_item.sender }}</span>
						</div>
						<div class="notice_content">{{ notice_zg_item.content }}</div>
						<div class="file">
							附件：<a :href="download + notice_zg_item.file" :download="notice_zg_item.filename">{{ notice_zg_item.filename }}</a>
						</div>
						<div class="notice_send_status">
							<div class="send_status">
								<div class="send_user">通知类型：{{ notice_zg_item.type==1?'仅通知':'任务整改' }}</div>
							</div>

							<div class="send_status">
								<span class="send_num">通知：{{ notice_zg_item.send_num }}家</span>
								<span class="success_num">成功：{{ notice_zg_item.success_num }}家</span>
								<span v-if="notice_zg_item.diff && notice_zg_item.diff.length>0" class="fail_num" title="点击查看失败企业列表" @click="show_fail_list(notice_zg_item.diff)">失败：{{ notice_zg_item.diff.length }}家</span>
							</div>
						</div>
					</div>
					<div class="fenge"></div>
					<div class="notice_reply_number">
						<span class="reply_num" :class="{'active':reply_status==1}" @click="change_status(1)">共回复：{{ notice_reply_number.reply_num?notice_reply_number.reply_num:0 }}家</span>
						<span class="reply_num" :class="{'active':reply_status==2}" @click="change_status(2)">未回复：{{ notice_reply_number.reply_num?notice_zg_item.success_num-notice_reply_number.reply_num:0 }}家</span>
						<span class="reply_num" :class="{'active':reply_status==3}" @click="change_status(3)">待审核：{{ notice_reply_number.reply_num1?notice_reply_number.reply_num1:0 }}家</span>
						<span class="reply_num" :class="{'active':reply_status==4}" @click="change_status(4)">整改完成：{{ notice_reply_number.reply_num2?notice_reply_number.reply_num2:0 }}家</span>
						<span class="reply_num" :class="{'active':reply_status==5}" @click="change_status(5)">重新整改：{{ notice_reply_number.reply_num3?notice_reply_number.reply_num3:0 }}家</span>
					</div>
					<el-input placeholder="搜索企业名称" style="margin-top:10px;" v-model="search_notice_factory_name" @input="search_notice_factory" clearable></el-input>
					<div class="notice_factory_list_box">
						<div class="notice_factory_list" v-if="notice_reply_list.length>0">
							<div class="notice_reply_status" :class="{'notice_factory_active':item.factory_id==notice_factory_active_id}" v-for="(item, index) in notice_reply_list" :key="item.id" @click="show_reply_info(item)">
								<div>
									<div style="margin-bottom:4px;">{{ item.unit_name }}</div>
									<div class="send_time">企业法人：{{ item.legal_person }} - {{ item.legal_person_tel }}</div>
									<div class="send_time">联系人：{{ item.user_name }} - {{ item.tel }}</div>
								</div>
								<div>
									<template v-if="!item.reply">
										<span>待企业回复</span>
									</template>
									<template v-else>
										<span v-if="item.status==0" class="yellow">待审核</span>
										<span v-else-if="item.status==1" class="green">已完成</span>
										<span v-else-if="item.status==2" class="red">审核拒绝</span>
									</template>
								</div>
							</div>
						</div>
						<div v-else class="no_data">
							<img src="../assets/no_tvoc.png" style="margin-top:10%;"/>
							<div>暂无数据</div>
						</div>
					</div>
				</div>
				<div class="notice_reply_box" v-if="is_show_reply_info">
					<div class="title2" style="margin-bottom:10px;">{{ reply_info_item.unit_name }}</div>
					<!-- <div class="send_time">联系人：{{ reply_info_item.user_name }}</div> -->
					<!-- <div class="send_time">联系电话：{{ reply_info_item.tel }}</div> -->
					<div v-if="reply_info_item.reply" style="flex-grow: 1;overflow: hidden auto;">
						<div v-for="(item,index) in reply_info_item.reply" class="factory_reply_item">
							<div class="reply_item_title">第{{ index+1 }}次回复</div>
							<div class="send_time">回复内容：{{ item.content }}</div>
							<div class="send_time">回复时间：{{ item.time }}</div>
							<div v-show="item.picture" class="img-box" ref="img-box" v-viewer="{ movable: false }">
								<div class="img_box">
									<div v-for="(ite, ins) in item.picture" :key="ins" class="img_item">
										<img v-lazy="download + ite" :key="download + ite" />
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="reply_info_item.reply" class='item notice_reply_examine_info' style="">
						<div v-if="reply_info_item.examine_user">
							<div class='center'>
								<span>上次处理意见</span>
							</div>
							<div class="block">
								<div>
									<div>处理结果</div>
								</div>
								<div>
									<span v-if="reply_info_item.status==1" class="green">审核通过</span>
									<span v-else-if="reply_info_item.status==2" class="red">审核解决</span>
								</div>
							</div>
							<div class="block">
								<div>
									<div>处理时间</div>
								</div>
								<div>
									<span>{{reply_info_item.examine_time}}</span>
								</div>
							</div>
							<div class="block">
								<div>
									<div>处理意见</div>
								</div>
								<div>
									<span>{{reply_info_item.examine_content==''?'未填写处理意见':reply_info_item.examine_content}}</span>
								</div>
							</div>
							<div class="block">
								<div>
									<div>处理人</div>
								</div>
								<div>
									<span>{{reply_info_item.examine_user}}</span>
								</div>
							</div>
						</div>
						<div v-if="reply_info_item.status!=1">
							<div class='center' :style="reply_info_item.examine_user?'margin-top:20px;':''">
								<span>审核整改材料</span>
							</div>
							<div class="block">
								<div>
									<div>解决问题<span class='red'>*</span></div>
								</div>
								<div>
									<el-select v-model="notice_reply_status" placeholder="请选择">
										<el-option v-for="(item,index) in notice_status" :value="index" :label="item" :key="index"></el-option>
									</el-select>
								</div>
							</div>
							<div class="block">
								<div>
									<div>处理意见</div>
								</div>
								<div>
									<el-input v-model="notice_reply_content" placeholder="请输入处理意见（选填）" class="resolution" />
								</div>
							</div>
							
							<div class='resolution_btn' @click="notice_reply_resolution()">
								<span>提交</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>

		<!-- 通知记录右侧弹窗 -->
		<el-drawer title="通知记录" :visible.sync="is_show_record" direction="rtl" class="record_box">
			<div style="padding: 0 24px;min-width:390px;">
				<div class="pop_notice_item" v-for="(item, index) in history" :key="index" @click="show_info(item)">
					<div class="title2">{{ item.title }}</div>
					<div class="send_time">{{ item.date }}</div>
					<div class="send_user">通知类型：{{ item.type==1?'仅通知':'任务整改' }}</div>
					<div class="send_info">
						<div class="send_user">发送人：{{ item.sender }}</div>
						<div>
							<span class="send_num">发送：{{ item.send_num }}家</span>
							<span class="success_num">成功：{{ item.success_num }}家</span>
						</div>
					</div>
				</div>
			</div>
		</el-drawer>

		<!-- 通知记录详情弹窗 -->
		<el-dialog title="通知记录" :visible.sync="dialogVisible" width="900px" top="8vh" height="80vh">
			<!-- <div class="el-dialog-div"> -->
				<div class="notice_item_info">
					<div class="title3">{{ notice_item.title }}</div>
					<div class="send_time2">
						<span>发送于：{{ notice_item.date }}</span>
						<span>{{ notice_item.sender }}</span>
					</div>
					<div class="notice_content">{{ notice_item.content }}</div>
					<div class="file">
						附件：<a :href="download + notice_item.file" :download="notice_item.filename">{{ notice_item.filename }}</a>
					</div>
					<div class="send_status">
						<div class="send_user">通知类型：{{ notice_item.type==1?'仅通知':'任务整改' }}</div>
					</div>

					<div class="send_status">
						<span class="send_num">发送：{{ notice_item.send_num }}家</span>
						<span class="success_num">成功：{{ notice_item.success_num }}家</span>
						<span v-if="notice_item.diff && notice_item.diff.length>0" class="fail_num" @click="show_fail_list(notice_item.diff)">失败：{{ notice_item.diff.length }}家</span>
					</div>
				</div>
				<div class="fenge"></div>
				<div class="notice_item_info">
					<div class="send_time2">发送企业</div>
					<div class="factory_box" v-if="notice_item.factory_name">
						<div class="factory_name" v-for="(value, key) in notice_item.factory_name.split(',')" :key="key">{{ value }}</div>
					</div>
				</div>
			<!-- </div> -->
			<div class="again_box">
				<el-button type="primary" class="again" @click="again()">通知复用</el-button>
			</div>
		</el-dialog>

		<el-drawer title="自排自查" :visible.sync="is_show_check" direction="rtl" class="record_box">
			<el-input placeholder="搜索企业名称" v-model="search_check_txt" style="position: absolute;top: 53px;left: 10px;right: 10px;width:auto;" @input="search_check" clearable></el-input>
			<div style="padding: 0 24px;min-width:390px;">
				<div v-if="check_self.length > 0">
					<div class="pop_check_item" v-for="(item, index) in check_self" :key="index">
						<div class="title2">{{ item.unit_name }}</div>
						<div class="send_time">备注信息：{{ item.remark }}</div>
						<div class="send_time">上传时间：{{ item.time }}</div>
						<div class="send_time">联系人：{{ item.user_name }}</div>
						<div class="send_time">联系电话：{{ item.tel }}</div>
						<div v-show="item.picture.split(',')" class="img-box" ref="img-box" v-viewer="{ movable: false }">
							<div class="img_box">
								<div v-for="(ite, ins) in item.picture.split(',')" :key="ins" class="img_item">
									<!-- :src="download+ite" -->
									<img v-lazy="download + ite" :key="download + ite" />
								</div>
							</div>
						</div>
						<div class="send_info">
							<div class="send_user"></div>
							<!-- <div>
								<el-switch
									@change="change_is_check($event,item.id)"
									v-model="item.is_check"
									active-value="1"
									active-color="#13ce66"
									inactive-color="#ff4949"
									active-text="已处理"
									inactive-text="待办">
								</el-switch>
							</div> -->
							<div class="check_over">
								<el-button type="primary" size="small" @click="change_is_check(true, item.id)">处理完成</el-button>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="no_data">
						<img src="../assets/no_tvoc.png" />
						<div>暂无数据</div>
					</div>
				</div>
			</div>
		</el-drawer>

		<el-drawer title="自查历史" :visible.sync="is_show_check_history" direction="rtl" class="record_box">
			<el-input placeholder="搜索企业名称" v-model="search_check_history_txt" style="position: absolute;top: 53px;left: 10px;right: 10px;width:auto;" @input="search_check_history" clearable></el-input>
			<div style="padding: 0 24px;min-width:390px;">
				<div v-if="check_history.length > 0">
					<div class="pop_check_item" v-for="(item, index) in check_history" :key="index">
						<div class="title2">{{ item.unit_name }}</div>
						<div class="send_time">备注信息：{{ item.remark }}</div>
						<div class="send_time">上传时间：{{ item.time }}</div>
						<div class="send_time">联系人：{{ item.user_name }}</div>
						<div class="send_time">联系电话：{{ item.tel }}</div>
						<div v-show="item.picture.split(',')" class="img-box" ref="img-box" v-viewer="{ movable: false }">
							<div class="img_box">
								<div v-for="(ite, ins) in item.picture.split(',')" :key="ins" class="img_item">
									<img v-lazy="download + ite" :key="download + ite" />
								</div>
							</div>
						</div>
						<div class="checked">已处理</div>
					</div>
				</div>
				<div v-else>
					<div class="no_data">
						<img src="../assets/no_tvoc.png" />
						<div>暂无数据</div>
					</div>
				</div>
			</div>
		</el-drawer>

		<el-drawer title="行政整改通知书" :visible.sync="is_show_rectification" direction="rtl" class="record_box">
			<div style="display:flex;justify-content: space-between;padding:0 12px;position: absolute;top: 53px;left: 10px;right: 10px;width:auto;">
				<div style="flex-grow: 1;">
					<el-input placeholder="搜索企业名称" v-model="search_rectification_txt" @input="search_rectification" clearable></el-input>
				</div>
				<div>
					<el-dropdown @command="handleChangeType">
						<el-button type="primary">
							{{type_arr[rectification_type]}}<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="index" v-for="(item,index) in type_arr" :key="index">{{item}}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
			<div style="padding: 0 24px;min-width:390px;"  v-infinite-scroll="load">
				<div v-if="rectification.length > 0">
					<div class="pop_check_item" v-for="(item, index) in rectification" :key="index">
						<div class="title2">{{ item.unit_name }}</div>
						<div class="send_time">地址：{{ item.address }}</div>
						<div class="send_time">联系人：{{ item.user_name }}</div>
						<div class="send_time">联系电话：{{ item.tel }}</div>

						<div class="send_time">整改标题：{{ item.title }}</div>
						<div class="send_time">整改说明：{{ item.content }}</div>
						<div class="send_time">整改期限至：{{ item.last_time }}</div>
						<div class="send_time">整改发起人：{{ item.u1name }}</div>

						<div v-show="item.picture.split(',')" class="img-box" ref="img-box" v-viewer="{ movable: false }">
							<div class="img_box">
								<div v-for="(ite, ins) in item.picture.split(',')" :key="ins" class="img_item">
									<img v-lazy="download + ite" :key="download + ite" />
								</div>
							</div>
						</div>

						<div v-if="item.status > 1">
							<div class="fenge_line"><span>整改回复</span></div>
							<div class="send_time">回复时间：{{ item.rr_time }}</div>
							<div class="send_time">回复内容：{{ item.rr_content }}</div>
							<div v-show="item.rr_picture.split(',')" class="img-box" ref="img-box" v-viewer="{ movable: false }">
								<div class="img_box">
									<div v-for="(ite, ins) in item.rr_picture.split(',')" :key="ins" class="img_item">
										<img v-lazy="download + ite" :key="download + ite" />
									</div>
								</div>
							</div>
						</div>

						<div v-if="item.status > 2">
							<div class="fenge_line"><span>结案内容</span></div>
							<div class="send_time">审核人：{{ item.u2name?item.u2name:'旧版未采集数据' }}</div>
							<div class="send_time">审核时间：{{ item.over_time?item.over_time:'-' }}</div>
							<div class="send_time">审核备注：{{ item.over_remark?item.over_remark:'-' }}</div>
						</div>

						<div v-if="item.status == 2" class="examine_btn">
							<el-button type="primary" size="mini" @click="examine(item.id,3,index)">审核通过</el-button>
							<el-button type="danger" size="mini" @click="examine(item.id,2,index)">审核拒绝</el-button>
						</div>
						<div class="checked" :class="'checked' + item.status" v-if="item.status == 1">
							<span v-if="item.last_time>server_date">待整改</span>
							<span v-else>超期</span>
						</div>
						<div class="checked" :class="'checked' + item.status" v-if="item.status == 2">待审核</div>
						<div class="checked" :class="'checked' + item.status" v-if="item.status == 3">已完成</div>
					</div>
				</div>
				<div v-else>
					<div class="no_data">
						<img src="../assets/no_tvoc.png" />
						<div>暂无数据</div>
					</div>
				</div>
			</div>
		</el-drawer>

		<el-drawer title="排查整改" :visible.sync="is_show_access_record" direction="rtl" class="record_box" :before-close="close_access_record">
			<div style="padding: 0 24px;min-width:390px;"  v-infinite-scroll="load">
				<div v-if="access_record && access_record.length > 0">
					<div class="pop_check_item" v-for="(item, index) in access_record" :key="index" style="padding:10px 0;">
						<div class="unit_name">
							<div style="font-weight: bold;font-size: 16px;">{{ item.unit_name }}</div>
							<div style="color:#999;font-size: 12px;">{{ item.time }}</div>
						</div>
						<div style="padding:10px">
							<div class="border">
								<div class="text">
									<span>企业地址</span>
								</div>
								<div class='value'>
									<span>{{item.address}}</span>
								</div>
							</div>
							<div class="border">
								<div class="text">
									<span>企业人数</span>
								</div>
								<div class='value'>
									<span>{{item.headcount}}人</span>
								</div>
							</div>
							<div class="border">
								<div class="text">
									<span>联系人</span>
								</div>
								<div class='value'>
									<span>{{item.user_name}}</span>
								</div>
							</div>
							<div class="border">
								<div class="text">
									<span>电话</span>
								</div>
								<div class='value'>
									<span>{{item.tel}}</span>
								</div>
							</div>
							<div class="border">
								<div class="text">审核状态</div>
								<div class="value">
									<span class="yellow" v-if="item.status=='0'">处理中</span>
									<span class="green" v-else-if="item.status=='1'">已解决</span>
									<span class="red" v-else-if="item.status=='2'">审核拒绝</span>
								</div>
							</div>
							<div class="border" v-if="item.status!='0'">
								<div class="text">
									<span>审核备注</span>
								</div>
								<div class='value'>
									<span>{{item.content==""?'未填写备注':item.content}}</span>
								</div>
							</div>
							<div class="border" v-if="item.status!='0'">
								<div class="text">
									<span>审核人员</span>
								</div>
								<div class='value'>
									<span>{{item.resolution_user}}</span>
								</div>
							</div>
							<div class="border" v-if="item.status!='0'">
								<div class="text">
									<span>审核时间</span>
								</div>
								<div class='value'>
									<span>{{item.receipt_time}}</span>
								</div>
							</div>
							<div class="border">
								<div class="text">
									<span>排查人员</span>
								</div>
								<div class='value'>
									<span>{{item.username}}</span>
								</div>
							</div>
							<div class="border ">
								<div class="text">
									<span>排查问题</span>
								</div>
								<div class='value'>
									<pre>{{item.remark==''?'未填写排查备注内容':item.remark}}</pre>
								</div>
							</div>
							<div class="border ">
								<div class="text">
									<span>整改期限</span>
								</div>
								<div class='value'>
									<pre>{{item.last_time}}</pre>
								</div>
							</div>
							<div class="border" style="display:block;">
								<div class="text">
									<span>上传照片</span>
								</div>
								<div v-show="item.picture.split(',')" class="value img-box" ref="img-box" v-viewer="{ movable: false }" style="max-width:100%;">
									<div class="img_box">
										<div v-for="(ite, ins) in item.picture.split(',')" :key="ins" class="img_item">
											<img v-lazy="download + ite" :key="download + ite" />
										</div>
										<div class="img_item">
											<img v-lazy="download + item.sign" :key="download + item.sign" />
										</div>
									</div>
								</div>
							</div>
						</div>
						<div style="padding:10px">
							<div class="push_box" style="display:block;">
								<div class="push_number">
									<span class="text">微信通知记录</span>
									<span>{{ item.wechat_push.length }}次</span>
								</div>
								<div v-for="(ite, ins) in item.wechat_push" :key="ins" class="push_item">
									<div>{{ ite.user }}</div>
									<div>{{ ite.time }}</div>
								</div>
							</div>
						</div>
						
						<div style="padding:10px">
							<div class="push_box" style="display:block;">
								<div class="push_number">
									<span class="text">电话通知记录</span>
									<span>{{ item.tel_notice.length }}次</span>
								</div>
								<div v-for="(ite, ins) in item.tel_notice" :key="ins" class="push_item">
									<div>{{ ite.user }}</div>
									<div>{{ ite.time }}</div>
								</div>
							</div>
						</div>
						<div v-if="!item.reply || item.status==2" class="push_btn">
							<div class='resolution_btn' @click="wechat_push(index)">
								<span>微信推送</span>
							</div>
							<div class='resolution_btn' @click="tel_notice(index)">
								<span>电话通知</span>
							</div>
						</div>
						<div v-if="item.history_reply" class="item" v-for="(item1,index1) in item.history_reply" :key="index1" style="padding:10px;">
							<div class="top_bar">
								<div class='time'>
									<div class='no'>第{{index1+1}}次整改回复</div>
								</div>
								<div>
									<div style="color: #808080;font-size: 12px;text-align: right;">
										<span>整改时间：{{item1.time}}</span>
									</div>
								</div>
							</div>
							
							<div class='info'>
								<div class="border">
									<div class="text">
										<span>整改时间</span>
									</div>
									<div class='value'>
										<span>{{item1.time}}</span>
									</div>
								</div>
								<div class="border">
									<div class="text">
										<span>回复内容</span>
									</div>
									<div class='value'>
										<span>{{item1.content}}</span>
									</div>
								</div>
								<div class="border" style="display:block;">
									<div class="text">
										<span>上传照片</span>
									</div>
									<div v-if="item1.picture" v-show="item1.picture.length>0" class="value img-box" ref="img-box" v-viewer="{ movable: false }">
										<div class="img_box">
											<div v-for="(ite, ins) in item1.picture" :key="ins" class="img_item">
												<img v-lazy="download + ite" :key="download + ite" />
											</div>
										</div>
									</div>
									<div v-else style="text-align:center;font-size:14px;color:#333;">
										<span>未上传照片</span>
									</div>
								</div>
							</div>
						</div>
						
						<div v-if="item.reply" class='item' style="padding:10px;border-top:1px dashed #1459e2;">
							<div v-if="item.resolution_user">
								<div class='center'>
									<span>上次处理意见</span>
								</div>
								<div class="block">
									<div>
										<div>上次处理时间</div>
									</div>
									<div>
										<span>{{item.receipt_time}}</span>
									</div>
								</div>
								<div class="block">
									<div>
										<div>上次处理意见</div>
									</div>
									<div>
										<span>{{item.content==''?'未填写处理意见':item.content}}</span>
									</div>
								</div>
								<div class="block">
									<div>
										<div>处理人</div>
									</div>
									<div>
										<span>{{item.resolution_user}}</span>
									</div>
								</div>
							</div>
							
							<div class='center' :style="item.resolution_user?'margin-top:20px;':''">
								<span>审核整改材料</span>
							</div>
							<div class="block">
								<div>
									<div>解决问题<span class='red'>*</span></div>
								</div>
								<div>
									<el-select v-model="item.index" placeholder="请选择">
										<el-option v-for="(item,index) in array" :value="index" :label="item" :key="index"></el-option>
									</el-select>
								</div>
							</div>
							<div class="block">
								<div>
									<div>处理意见</div>
								</div>
								<div>
									<el-input v-model="item.receipt_content" placeholder="请输入处理意见（选填）" class="resolution" />
								</div>
							</div>
							
							<div class='resolution_btn' @click="resolution(index)">
								<span>提交</span>
							</div>
						</div>
						<div v-else style="padding:10px;">
							<div class="center">未提交整改材料</div>
							<div class="confirm_over" @click="confirm_over(item)">人工确认整改完毕</div>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="no_data">
						<img src="../assets/no_tvoc.png" />
						<div>暂无数据</div>
					</div>
				</div>
				
			</div>
		</el-drawer>

		<el-drawer title="排查整改-企业列表" :visible.sync="is_show_factory_list" direction="rtl" class="record_box">
			<div style="display:flex;justify-content: space-between;padding:0 12px;position: absolute;top: 53px;left: 10px;right: 10px;width:auto;">
				<div style="flex-grow: 1;">
					<el-input placeholder="搜索企业名称" v-model="search_access_record_txt" @input="search_access_record" clearable></el-input>
				</div>
				<div>
					<el-dropdown @command="handleChangeFactoryRegion">
						<el-button type="primary">
							{{region_arr[region_index]}}<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="index" v-for="(item,index) in region_arr" :key="index">{{item}}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
			<div style="padding: 0 24px;min-width:390px;"  v-infinite-scroll="load">
				<div class="factory_item" @click="show_access_problem(item.id,item.problem_num)" v-for="(item,index) in factory_access" :key="item.id">
					<div class="factory_unit_name">{{ item.unit_name }}</div>
					<div class="factory_address">{{ item.address }}</div>
					<div class="problem_num " v-if="item.problem_num>0">排查问题数量: {{ item.problem_num }} 次</div>
					<div class="problem_num is_problem" v-else>当前企业暂无问题</div>
				</div>
			</div>
		</el-drawer>

		<!-- 通知失败企业列表 -->
		<el-dialog title="通知失败企业列表" :visible.sync="is_show_fail_factory" width="900px">
			<div class="notice_item_info">
				<div class="factory_box" style="margin-top:0;">
					<div class="factory_name" v-for="(value, key) in fail_factory" :key="key">{{ value }}</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			token: window.localStorage.getItem("token"),
			domain: this.$store.state.domain,
			download: this.$store.state.download,
			notice_type_arr:[
				{value: '1',label: '仅通知'},
				{value: '2',label: '任务整改'}
			],
			notice_type:'',
			region_arr: ["不限", "十陵", "西河", "洪安", "洛带", "同安", "柏合", "东安", "龙泉", "大面"],
			class_arr: ["不限","一类", "二类", "三类"],
			factory: [],
			factory_copy: [],
			set_region: "",
			set_class: "",
			new_energy: ['不限','是新能源','非新能源'],
			set_new_energy: "",
			set_factory: [],
			title: "",
			content: "",
			fileList: [],
			history: [],
			is_show_record: false,
			dialogVisible: false,
			check_self: [],
			check_self_copy: [],
			search_check_txt: "",
			is_show_check: false,

			check_history: [],
			search_check_history_txt: "",
			check_history_copy: [],
			is_show_check_history: false,

			check_self_dialogVisible: false,
			notice_item: {},
			style: window.localStorage.getItem("style") ? window.localStorage.getItem("style") : 1, //获取本地style
			mode: window.localStorage.getItem("mode") ? window.localStorage.getItem("mode") : "light", //获取本地mode

			search_rectification_txt: "",
			rectification: [],
			is_show_rectification: false,
			rectification_type: 0,
			type_arr: ["不限", "待整改", "待审核", "已结案", "超期未整改"],
			timer: null,
			server_date: "",
			is_rectification_loading: false,
			rectification_page: 1,

			is_show_access_record:false,
			search_access_record_txt:'',
			access_record:[],
			access_record_copy:[],
			access_record_page:1,
			is_access_record_loading:false,
			array: ['已解决', '未解决'],
			is_show_factory_list:false,
			handle_access_record:false,	//是否处理过排查记录标识符

			factory_access:[],
			problem_type:['全部企业','问题企业','待审核','已结案'],
			problem_type_index:0,
			region_index:0,

			//任务整改
			is_show_notice:false,
			notice_zg:[],
			notice_zg_dialogVisible: false,
			notice_zg_item:{},
			notice_reply_list:[],
			notice_reply_list_bak:[],
			notice_factory_active_id:null,
			notice_reply_number:{},
			is_show_reply_info:false,
			reply_info_item:{},
			notice_status: ['已解决','未解决'],
			notice_reply_content:'',
			notice_reply_status:null,
			search_notice_factory_name:'',
			reply_status:0,

			//企业筛选
			check_arr:[],
			conditions:['尾气治理','二级维护','机修','漆房','轮胎','电器'],

			//失败企业列表
			is_show_fail_factory:false,
			fail_factory:[],
		};
	},

	mounted() {
		//获取本地style
		this.token = window.localStorage.getItem("token");
		//设置默认主题
		document.querySelector("html").className = this.mode;

		if (!this.token) {
			uni.reLaunch({
				url: "./login",
			});
		}

		this.get_data();
		this.get_notice();

		// this.show_access_reocrd()
	},
	//方法
	methods: {
		change_condition(val){
			console.log(this.set_region, this.set_class,this.check_arr,this.set_new_energy)
			// console.log(val)
			// console.log(this.check_arr)
			// this.get_data();
			// console.log(val)
			//筛选企业列表factory_copy，通过val条件
			this.factory = this.factory_copy.filter(item=>{
				//解决数据同源问题
				if(this.set_factory.indexOf(item.id) != -1){
					return true
				}else{
					var flag1 = false;
					var flag2 = false;
					var flag3 = false;
					var flag4 = false;
					// 筛选区域
					if(this.set_region == '' || this.set_region == '不限'){
						flag1 = true
					}else{
						flag1 = item.region == this.set_region
					}
					// 筛选类别
					if(this.set_class == '' || this.set_class == '不限'){
						flag2 = true
					}else{
						if(this.set_class == '一类'){
							flag2 = item.class == 1
						}else if(this.set_class == '二类'){
							flag2 = item.class == 2
						}else if(this.set_class == '三类'){
							flag2 = item.class == 3
						}
					}
					// 筛选条件
					if(this.check_arr.length == 0){
						flag3 = true
					}else{
						for(let i=0;i<this.check_arr.length;i++){
							var type = this.check_arr[i];
							var type_arr = item.type.split(',');
							console.log(type_arr)
							switch(type){
								case '尾气治理':
									flag3 = item.mzhan == 1
									break;
								case '二级维护':
									flag3 = item.ejwh == 1
									break;
								case '机修':
									flag3 = type_arr.indexOf('jx') != -1
									break;
								case '漆房':
									flag3 = type_arr.indexOf('qf') != -1
									break;
								case '轮胎':
									flag3 = type_arr.indexOf('lt') != -1
									break;
								case '电器':
									flag3 = type_arr.indexOf('dp') != -1
									break;
							}
							if(!flag3){
								break;
							}
						}
						console.log(flag3)
					}
					
					//筛选新能源
					if(this.set_new_energy == '不限' || this.set_new_energy == ''){
						flag4 = true
					}else{
						flag4 = item.new_energy == (this.set_new_energy=='是新能源'?'1':'0');
					}
					return flag1 && flag2 && flag3 && flag4;
				}
				
				
			})

		},
		//切换风格
		change_mode() {
			this.mode = this.mode == "light" ? "dark" : "light";
			// 给html标签添加class
			document.querySelector("html").className = this.mode;
			//保存本地
			window.localStorage.setItem("mode", this.mode);
		},
		change_style(i) {
			this.style = i;
			//保存本地
			window.localStorage.setItem("style", i);
		},
		//选择文件后，删除上一个文件
		handleFileChange(file, fileList) {
			if (fileList.length > 1) {
				fileList.splice(0, 1);
			}
			this.fileList = fileList;
		},
		get_data() {
			this.loading = this.$loading({
				lock: true,
				text: "数据查询中...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.4)",
			});
			var _this = this;
			this.$axios
				.post(this.$store.state.domain + "/get_factory_list", {
					token: window.localStorage.getItem("token"),
					// region: this.set_region,
					// class: this.set_class,
					// type_arr:this.check_arr
				})
				.then(function(res) {
					// console.log(res);
					_this.loading.close();
					if (res.data.code == "200ok") {
						var factory = res.data.data;
						for (var i = 0; i < factory.length; i++) {
							factory[i].unit_name = "(" + (factory[i].region ? factory[i].region : "无") + ") " + factory[i].unit_name;
							if (factory[i].openid == "" || factory[i].openid == null) {
								factory[i].unit_name = "【未入驻】" + factory[i].unit_name;
								factory[i].disabled = true;
							}
						}
						_this.factory = factory;
						_this.factory_copy = factory;
					} else {
						_this.$message.error(data.msg);
					}
				})
				.catch(function(error) {
					console.log(error);
					_this.loading.close();
					_this.$message.error("网络异常,数据请求失败");
				});
		},
		reset_search() {
			this.set_region = "";
			this.set_class = "";
			this.set_factory = [];
			this.check_arr = [];
			this.get_data();
			this.$nextTick(() => {
				this.$refs.roleTransfer.clearQuery("left");
				this.$refs.roleTransfer.clearQuery("right");
			});
		},
		submitUpload() {
			if (this.notice_type == "") {
				this.$message.error("请选择通知类型");
				return;
			}
			if (this.set_factory.length == 0) {
				this.$message.error("请选择接收企业");
				return;
			}
			if (this.title == "") {
				this.$message.error("请输入标题");
				return;
			}
			if (this.content == "") {
				this.$message.error("请输入正文");
				return;
			}
			if (this.fileList.length == 0) {
				this.$message.error("请上传附件");
				return;
			}
			this.$refs.upload.submit();
		},
		send_notice(data) {
			var _this = this;

			this.loading = this.$loading({
				lock: true,
				text: "数据提交中...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.4)",
			});
			var formData = new FormData();
			formData.append("token", window.localStorage.getItem("token"));
			formData.append("file", data.file);
			formData.append("type", this.notice_type);
			formData.append("title", this.title);
			formData.append("content", this.content);
			formData.append("factory", this.set_factory);
			this.$axios
				.post(this.$store.state.domain + "/send_notice", formData)
				.then(function(res) {
					// console.log(res);
					_this.loading.close();
					if (res.data.code == "200ok") {
						_this.$message.success(res.data.msg);
						_this.fileList = [];
						_this.title = "";
						_this.content = "";

						_this.reset_search();
						_this.get_notice();
					} else {
						_this.$message.error(res.data.msg);
					}
				})
				.catch(function(error) {
					console.log(error);
					_this.loading.close();
					_this.$message.error("网络异常,数据请求失败");
				});
		},
		//查询发送记录
		get_notice() {
			var _this = this;
			this.$axios
				.post(this.$store.state.domain + "/get_notice_history", {
					token: window.localStorage.getItem("token"),
				})
				.then(function(res) {
					// console.log(res);
					if (res.data.code == "200ok") {
						_this.history = res.data.data;
					} else {
						_this.history = [];
						_this.$message.error(data.msg);
					}
				})
				.catch(function(error) {
					console.log(error);
					_this.$message.error("网络异常,数据请求失败");
				});
		},
		show_record() {
			this.is_show_record = true;
		},
		show_info(item) {
			//查询失败企业
			var _this = this;
			//对比success_factory和factory_id的差集
			var success_factory = item.success_factory.split(",");
			var factory_id = item.factory_id.split(",");
			var diff = factory_id.filter(function(v) {
				return !success_factory.includes(v);
			});
			item.diff = diff;

			this.notice_item = item;
			// this.drawer = true;
			this.dialogVisible = true;
		},

		//显示任务整改列表
		show_notice(action="open"){
			var _this = this;
			this.loading = this.$loading({
				lock: true,
				text: "数据查询中...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.4)",
			});
			this.$axios
				.post(this.$store.state.domain + "/get_notice_zg", {
					token: window.localStorage.getItem("token"),
				})
				.then(function(res) {
					// console.log(res);
					_this.loading.close();
					if (res.data.code == "200ok") {
						_this.notice_zg = res.data.data;
						if(action=="open"){
							_this.is_show_notice = true;
						}
					} else {
						_this.notice_zg = [];
						_this.$message.error(data.msg);
					}
				})
				.catch(function(error) {
					console.log(error);
					_this.loading.close();
					_this.$message.error("网络异常,数据请求失败");
				});
		},
		//显示任务整改详情
		show_notice_info(item){
			//获取item中factory_id和success_factory的差集
			var factory_id = item.factory_id.split(",");
			var success_factory = item.success_factory.split(",");
			var diff = factory_id.filter(function(v) {
				return !success_factory.includes(v);
			});
			item.diff = diff;
			this.notice_zg_item = item;
			this.get_notice_reply_to_id(item.id,item.factory_id)
		},
		//查询任务整改企业回复记录
		get_notice_reply_to_id(notice_id,factory_id){
			this.search_check_txt = "";	//查询条件
			this.search_notice_factory_name = "";	//查询企业列表条件
			this.reply_status=0;	//被选中的企业状态
			this.is_show_reply_info = false;	//是否显示回复右侧详情
			this.reply_info_item = {};	//回复详情内容
			this.notice_factory_active_id = "";	//被选中的企业id

			var _this = this;
			this.loading = this.$loading({
				lock: true,
				text: "数据查询中...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.4)",
			});
			this.$axios
				.post(this.$store.state.domain + "/get_notice_reply_to_id", {
					token: window.localStorage.getItem("token"),
					id:notice_id,
					factory_id:factory_id
				})
				.then(function(res) {
					console.log(res);
					_this.loading.close();
					if (res.data.code == "200ok") {
						_this.notice_reply_list = res.data.data;
						_this.notice_reply_list_bak = res.data.data;
						_this.notice_reply_number = res.data.notice_reply_number;
						_this.notice_zg_dialogVisible = true;
					} else {
						_this.notice_reply_list = [];
						_this.$message.error(data.msg);
					}
				})
				.catch(function(error) {
					console.log(error);
					_this.loading.close();
					_this.$message.error("网络异常,数据请求失败");
				});
		},

		//显示失败企业列表
		show_fail_list(fail_id){
			var _this = this;
			console.log(fail_id)
			this.loading = this.$loading({
				lock: true,
				text: "数据加载中...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.4)",
			});
			this.$axios
			.post(this.$store.state.domain + "/get_fail_factory", {
				token: window.localStorage.getItem("token"),
				diff: fail_id.join(","),
			})
			.then(function(res) {
				// console.log(res);
				if (res.data.code == "200ok") {
					_this.fail_factory = res.data.fail_factory;
				} else {
					_this.fail_factory = [];
					_this.$message.error(res.data.msg);
				}

				_this.is_show_fail_factory = true;
				_this.loading.close();
			})
			.catch(function(error) {
				console.log(error);
				_this.$message.error("网络异常,数据请求失败");
				_this.loading.close();
			});
		},
		//输入搜索发送通知企业，事件抖动
		search_notice_factory(now=false){
			if (this.timer) {
				clearTimeout(this.timer);
			}
			this.timer = setTimeout(()=>{
				//关闭右侧
				//this.is_show_reply_info = false;
				this.reply_info_item = {};
				this.notice_factory_active_id = "";
				//筛选状态
				var status = this.reply_status;
				var temp_list = [];
				if(status==0){
					temp_list = this.notice_reply_list_bak;
				}else{
					if(status==1){
						temp_list = this.notice_reply_list_bak.filter((item)=>{
							return item.reply!=null;
						})
					}else if(status==2){
						temp_list = this.notice_reply_list_bak.filter((item)=>{
							return item.reply==null;
						})
					}else if(status==3){
						temp_list = this.notice_reply_list_bak.filter((item)=>{
							return item.reply!=null && item.status==0;
						})
					}else if(status==4){
						temp_list = this.notice_reply_list_bak.filter((item)=>{
							return item.reply!=null && item.status==1;
						})
					}else if(status==5){
						temp_list = this.notice_reply_list_bak.filter((item)=>{
							return item.reply!=null && item.status==2;
						})
					}
				}
				
				//筛选notice_reply_list，通过notice_reply_list_bak中的unit_name
				if(this.search_notice_factory_name==""){
					this.notice_reply_list = temp_list;
				}else{
					this.notice_reply_list = temp_list.filter((item)=>{
						return item.unit_name.indexOf(this.search_notice_factory_name)>-1;
					})
				}
			}, now?0:500);
		},
		change_status(status){
			this.search_notice_factory_name = "";
			if(status==this.reply_status){
				this.reply_status = 0;
				this.notice_reply_list = this.notice_reply_list_bak;
				return false;
			}
			
			this.reply_status = status;
			//status 1:已回复 2:未回复 3:待审核 4:整改完成 5:审核不通过
			this.search_notice_factory(true);
		},
		//显示任务整改回复详情
		show_reply_info(item){
			console.log(item)
			this.notice_factory_active_id = item.factory_id;
			//未回复
			if(item.reply==null){
				this.$message.error("该企业任务整改未回复");
				return false;
			}
			if(this.reply_info_item && this.reply_info_item.notice_reply_id != item.notice_reply_id){
				this.reply_info_item = {};
				this.notice_reply_content = "";
				this.notice_reply_status = null;
				if(item.reply && !Array.isArray(item.reply)){
					item.reply = JSON.parse(item.reply);
				}
				this.reply_info_item = item;
				this.is_show_reply_info = true;
			}
		},
		//关闭任务整改回复弹窗
		close_notice_zg(done){
			done();
			setTimeout(()=>{
				this.reply_info_item = {};
				this.is_show_reply_info = false;
			},500)
		},
		//审核任务整改
		notice_reply_resolution(){
			var _this = this;
			var data = this.reply_info_item;
			console.log(data)
			//必选项
			if(this.notice_reply_status==null){
				_this.$message.error('请选择任务是否已解决')
				return false;
			}

			if(this.notice_status[this.notice_reply_status]=='未解决' && this.notice_reply_content==''){
				_this.$message.error('请输入审核拒绝处理意见')
				return false;
			}
			_this.loading = this.$loading({
				lock: true,
				text: "数据提交中...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.4)",
			});
			//确认修改
			_this.$axios
			.post(_this.$store.state.domain + "/examine_notice_reply", {
				openid: window.localStorage.getItem("openid"),
				factory_id: data.factory_id,
				notice_reply_id: data.notice_reply_id,
				notice_id: data.notice_id,
				check_time: data.check_time,
				status: this.notice_reply_status,
				remark: this.notice_reply_content,
				// time: data.time
			})
			.then(function(res) {
				_this.loading.close();
				// console.log(res);
				if (res.data.code == "200ok") {
					//更新审核结果
					_this.show_notice('refresh')
					_this.get_notice_reply_to_id(data.notice_id,_this.notice_zg_item.factory_id)
					_this.reply_info_item = {};
					_this.is_show_reply_info = false;
					_this.$message.success(res.data.msg);
				} else {
					_this.$message.error(res.data.msg);
				}
			})
			.catch(function(error) {
				_this.loading.close();
				console.log(error);
				_this.$message.error("网络异常,数据请求失败");
			});
		},

		//显示自查记录
		show_check_self() {
			this.search_check_txt = "";
			var _this = this;
			this.loading = this.$loading({
				lock: true,
				text: "数据查询中...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.4)",
			});
			this.$axios
				.post(this.$store.state.domain + "/get_check_self", {
					token: window.localStorage.getItem("token"),
				})
				.then(function(res) {
					// console.log(res);
					_this.loading.close();
					if (res.data.code == "200ok") {
						_this.check_self = res.data.data;
						_this.check_self_copy = res.data.data;
						_this.is_show_check = true;
					} else {
						_this.check_self = [];
						_this.$message.error(data.msg);
					}
				})
				.catch(function(error) {
					console.log(error);
					_this.loading.close();
					_this.$message.error("网络异常,数据请求失败");
				});
		},
		//显示自查历史
		show_check_history() {
			this.search_check_history_txt = "";
			//查询自查历史
			var _this = this;
			this.loading = this.$loading({
				lock: true,
				text: "数据查询中...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.4)",
			});
			this.$axios
				.post(this.$store.state.domain + "/get_check_history", {
					token: window.localStorage.getItem("token"),
				})
				.then(function(res) {
					// console.log(res);
					_this.loading.close();
					if (res.data.code == "200ok") {
						_this.check_history = res.data.data;
						_this.check_history_copy = res.data.data;
						_this.is_show_check_history = true;
					} else {
						_this.check_history = [];
						_this.$message.error(data.msg);
					}
				})
				.catch(function(error) {
					console.log(error);
					_this.loading.close();
					_this.$message.error("网络异常,数据请求失败");
				});
		},
		
		//搜索自查
		search_check(search) {
			// 搜索check_self中的数据unit_name
			var search_list = [];
			if (search == "") {
				this.check_self = this.check_self_copy;
			} else {
				this.check_self_copy.forEach(function(item) {
					if (item.unit_name.indexOf(search) != -1) {
						search_list.push(item);
					}
				});
				this.check_self = search_list;
			}
		},
		//搜索自查历史
		search_check_history(search) {
			console.log(search);
			// 搜索check_self中的数据unit_name
			var search_list = [];
			if (search == "") {
				this.check_history = this.check_history_copy;
			} else {
				this.check_history_copy.forEach(function(item) {
					if (item.unit_name.indexOf(search) != -1) {
						search_list.push(item);
					}
				});
				this.check_history = search_list;
			}
		},

		//修改处理状态
		change_is_check(e, id) {
			var _this = this;
			//弹出确认框
			this.$confirm("确认修改处理状态吗?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					//确认修改
					_this.$axios
						.post(_this.$store.state.domain + "/change_check_self_status", {
							token: window.localStorage.getItem("token"),
							id: id,
							is_check: e ? 1 : 0,
						})
						.then(function(res) {
							// console.log(res);
							if (res.data.code == "200ok") {
								_this.$message.success(res.data.msg);
							} else {
								_this.$message.error(res.data.msg);
							}
						})
						.catch(function(error) {
							console.log(error);
							_this.$message.error("网络异常,数据请求失败");
						});
				})
				.catch(() => {
					//取消修改
					_this.$message({
						type: "info",
						message: "已取消修改",
					});
				});
		},
		//通知复用
		again() {
			this.title = this.notice_item.title;
			this.content = this.notice_item.content;
			this.set_factory = this.notice_item.factory_id.split(","); //选择的
			// this.set_factory = this.notice_item.success_factory.split(",");	//成功的

			this.$nextTick(() => {
				this.$refs.roleTransfer.clearQuery("left");
				this.$refs.roleTransfer.clearQuery("right");
			});
			//关闭弹窗
			this.dialogVisible = false;
			this.is_show_record = false;
		},

		//显示整改记录
		show_rectification() {
			this.search_rectification_txt = "";
			this.is_show_rectification = true;
			this.get_rectification();
		},
		get_rectification(){
			//记录请求中
			this.is_rectification_loading = true;
			//查询自查历史
			var _this = this;
			this.loading = this.$loading({
				lock: true,
				text: "数据查询中...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.4)",
			});
			this.$axios
				.post(this.$store.state.domain + "/get_rectification", {
					token: window.localStorage.getItem("token"),
					page: this.rectification_page,
					unit_name: this.search_rectification_txt,
					type:this.rectification_type
				})
				.then(function(res) {
					console.log(res);
					_this.loading.close();
					if (res.data.code == "200ok") {
						_this.server_date = res.data.server_date;
						
						if(_this.rectification_page==1){
							_this.rectification = res.data.data;
						}else{
							_this.rectification = _this.rectification.concat(res.data.data);
						}
					} else {
						_this.rectification = [];
						_this.$message.error(data.msg);
					}
					_this.is_rectification_loading = false;
				})
				.catch(function(error) {
					_this.is_rectification_loading = false;
					console.log(error);
					_this.loading.close();
					_this.$message.error("网络异常,数据请求失败");
				});
		},
		examine(id,status,index) {
			var _this = this;
			if(status==2){
				this.$alert('如需拒绝审核，请前往小程序拒绝并修改整改通知内容！！', '温馨提示', {
					confirmButtonText: '确定',
				});
				return false;
			}
			this.$prompt("请输入审核意见", "审核整改通知", {
				confirmButtonText: "提交",
				cancelButtonText: "取消",
			})
			.then(({ value }) => {
				if(value==""){
					_this.$message({
						type: "info",
						message: "请输入审核意见",
						duration: 1500,
					});
					return false;
				}
				_this.loading = this.$loading({
					lock: true,
					text: "数据提交中...",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.4)",
				});
				//确认修改
				_this.$axios
					.post(_this.$store.state.domain + "/over_rectification", {
						openid: window.localStorage.getItem("openid"),
						id: id,
						status: status,
						remark:value
					})
					.then(function(res) {
						_this.loading.close();
						// console.log(res);
						if (res.data.code == "200ok") {
							_this.rectification[index].status = status;
							_this.rectification[index].u2name = res.data.data.u2name;
							_this.rectification[index].over_time = res.data.data.over_time;
							_this.rectification[index].over_remark = res.data.data.remark;
							_this.$message.success(res.data.msg);
						} else {
							_this.$message.error(res.data.msg);
						}
					})
					.catch(function(error) {
						_this.loading.close();
						console.log(error);
						_this.$message.error("网络异常,数据请求失败");
					});
			})
			.catch(() => {
				
			});
		},
		handleChangeType(val) {
			this.rectification_type = val;
			this.rectification_page = 1;
			this.get_rectification();
		},
		
		search_rectification(){
			//事件抖动，调用多次只执行最后一次，调用get_rectification方法
			if (this.timer) {
				clearTimeout(this.timer);
			}
			this.timer = setTimeout(()=>{
				this.rectification_type = 0;
				this.rectification_page = 1;
				this.get_rectification();
			}, 500);
		},
		search_access_record(){
			//事件抖动，调用多次只执行最后一次，调用get_rectification方法
			if (this.timer) {
				clearTimeout(this.timer);
			}
			this.timer = setTimeout(()=>{
				this.rectification_type = 0;
				this.rectification_page = 1;
				this.show_access_reocrd();
			}, 500);
		},
		
		//上拉加载
		load(){
			//如何总数小于当前页数，不再加载
			if(this.rectification.length<this.rectification_page*10){
				return false;
			}
			//请求中，不再加载
			if(this.is_rectification_loading){
				return false;
			}
			this.is_rectification_loading = true;
			this.rectification_page++;
			this.get_rectification();
		},
		//显示企业列表+排查
		show_access_reocrd(){
			// this.search_access_record_txt = "";
			var _this = this;
			this.loading = this.$loading({
				lock: true,
				text: "数据查询中...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.4)",
			});
			this.$axios
			.post(this.$store.state.domain + "/get_factory_and_access", {
				token: window.localStorage.getItem("token"),
				unit_name: this.search_access_record_txt,
				region:this.region_arr[this.region_index]
			})
			.then(function(res) {
				// console.log(res);
				_this.loading.close();
				if (res.data.code == "200ok") {
					_this.factory_access = res.data.data;
					_this.is_show_factory_list = true;
				} else {
					_this.access_record = [];
					_this.$message.error(data.msg);
				}
			})
			.catch(function(error) {
				console.log(error);
				_this.loading.close();
				_this.$message.error("网络异常,数据请求失败");
			});
		},
		//切换企业地区
		handleChangeFactoryRegion(val){
			this.region_index = val;
			this.show_access_reocrd();
		},
		//显示排查整改记录
		// show_access_reocrd(){
		// 	var _this = this;
		// 	this.loading = this.$loading({
		// 		lock: true,
		// 		text: "数据查询中...",
		// 		spinner: "el-icon-loading",
		// 		background: "rgba(0, 0, 0, 0.4)",
		// 	});
		// 	this.$axios
		// 		.post(this.$store.state.domain + "/get_access_record_and_reply", {
		// 			token: window.localStorage.getItem("token"),
		// 			unit_name: this.search_access_record_txt,
		// 		})
		// 		.then(function(res) {
		// 			// console.log(res);
		// 			_this.loading.close();
		// 			if (res.data.code == "200ok") {
		// 				var access_record = res.data.access_record
		// 				for(var i = 0;i<access_record.length;i++){
		// 					if(access_record[i].history_reply){
		// 						access_record[i].history_reply = JSON.parse(access_record[i].history_reply)
		// 					}else{
		// 						access_record[i].history_reply = []
		// 					}

		// 					if(access_record[i].wechat_push){
		// 						access_record[i].wechat_push = JSON.parse(access_record[i].wechat_push)
		// 					}else{
		// 						access_record[i].wechat_push = []
		// 					}

		// 					if(access_record[i].tel_notice){
		// 						access_record[i].tel_notice = JSON.parse(access_record[i].tel_notice)
		// 					}else{
		// 						access_record[i].tel_notice = []
		// 					}
		// 					access_record[i].index=null;
		// 					access_record[i].receipt_content='';
		// 				}
		// 				_this.access_record = access_record;
		// 				_this.access_record_copy = access_record;
		// 				_this.is_show_access_record = true;
		// 			} else {
		// 				_this.access_record = [];
		// 				_this.$message.error(data.msg);
		// 			}
		// 		})
		// 		.catch(function(error) {
		// 			console.log(error);
		// 			_this.loading.close();
		// 			_this.$message.error("网络异常,数据请求失败");
		// 		});
		// },
		//显示排查记录
		show_access_problem(factory_id,problem_num){
			if(problem_num == 0){
				this.$message.error("当前企业暂无问题");
				return false;
			}
			var _this = this;
			this.loading = this.$loading({
				lock: true,
				text: "数据查询中...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.4)",
			});
			this.$axios
			.post(this.$store.state.domain + "/get_access_record_and_reply_to_factoryid", {
				token: window.localStorage.getItem("token"),
				factory_id: factory_id,
			})
			.then(function(res) {
				console.log(res);
				_this.loading.close();
				if (res.data.code == "200ok") {
					var access_record = res.data.access_record;
					console.log(access_record)
					for(var i = 0;i<access_record.length;i++){
						if(access_record[i].history_reply){
							access_record[i].history_reply = JSON.parse(access_record[i].history_reply)
						}else{
							access_record[i].history_reply = []
						}

						if(access_record[i].wechat_push){
							access_record[i].wechat_push = JSON.parse(access_record[i].wechat_push)
						}else{
							access_record[i].wechat_push = []
						}

						if(access_record[i].tel_notice){
							access_record[i].tel_notice = JSON.parse(access_record[i].tel_notice)
						}else{
							access_record[i].tel_notice = []
						}
						access_record[i].index=null;
						access_record[i].receipt_content='';
					}
					_this.access_record = access_record;
					_this.access_record_copy = access_record;
					_this.is_show_access_record = true;

					console.log(_this.access_record)
				} else {
					_this.access_record = [];
					_this.$message.error(data.msg);
				}
			})
			.catch(function(error) {
				console.log(error);
				_this.loading.close();
				_this.$message.error("网络异常,数据请求失败");
			});
		},
		//关闭排查整改
		close_access_record(done){
			done();
			if(this.handle_access_record){
				this.show_access_reocrd();
			}
		},
		//人工确认整改完成
		confirm_over(data){
			console.log(data)
			var _this = this;
			var id = data.id;
			//是否确认弹窗
			this.$confirm('是否确认整改完成?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.handle_access_record = true;
				var _this = this;
				this.loading = this.$loading({
					lock: true,
					text: "数据提交中...",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.4)",
				});
				this.$axios
				.post(this.$store.state.domain + "/artificial_confirm_over", {
					id: id,
					openid:window.localStorage.getItem("openid"),
				})
				.then(function(res) {
					console.log(res);
					_this.loading.close();
					if (res.data.code == "200ok") {
						_this.$message.success('处理成功');
						_this.show_access_problem(data.factory_id,1);
					} else {
						_this.$message.error(data.msg);
					}
				})
				.catch(function(error) {
					console.log(error);
					_this.loading.close();
					_this.$message.error("网络异常,数据请求失败");
				});
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});
			});
			
		},
		//审核排查问题
		resolution(index){
			console.log(index)
			var _this = this;
			var data = this.access_record[index];
			//必选项
			if(data.index==null){
				_this.$message.error('请选择企业是否解决问题')
				return false;
			}

			if(this.array[data.index]=='未解决' && data.remark==''){
				_this.$message.error('请输入审核拒绝处理意见')
				return false;
			}
			console.log(data)
			this.loading = this.$loading({
				lock: true,
				text: "数据提交中...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.4)",
			});
			this.handle_access_record = true;
			//确认修改
			_this.$axios
			.post(_this.$store.state.domain + "/examine_access_reply", {
				openid: window.localStorage.getItem("openid"),
				id: data.id,
				status: data.index,
				remark: data.receipt_content,
				factory_id: data.factory_id,
				time: data.time
			})
			.then(function(res) {
				_this.loading.close();
				// console.log(res);
				if (res.data.code == "200ok") {
					//删除当前数据
					_this.access_record.splice(index,1);
					_this.$message.success(res.data.msg);
				} else {
					_this.$message.error(res.data.msg);
				}
			})
			.catch(function(error) {
				_this.loading.close();
				console.log(error);
				_this.$message.error("网络异常,数据请求失败");
			});
		},
		//微信通知
		wechat_push(index){
			console.log(index)
			var _this = this;
			var data = this.access_record[index];
			console.log(data)
			this.$confirm('是否给企业发送排查整改通知?', '提示', {
				confirmButtonText: '发送',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				_this.loading = this.$loading({
					lock: true,
					text: "通知发送中...",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.4)",
				});
				//确认修改
				_this.$axios
				.post(_this.$store.state.domain + "/wechat_push", {
					openid: window.localStorage.getItem("openid"),
					id: data.id,
					factory_id: data.factory_id,
				}).then(function(res) {
					_this.loading.close();
					// console.log(res);
					if (res.data.code == "200ok") {
						_this.$message.success(res.data.msg);
						_this.access_record[index].wechat_push = res.data.data;
					} else {
						_this.$message.error(res.data.msg);
					}
				}).catch(function(error) {
					_this.loading.close();
					console.log(error);
					_this.$message.error("网络异常,数据请求失败");
				});
			});
		},
		//电话通知
		tel_notice(index){
			console.log(index)
			var _this = this;
			var data = this.access_record[index];
			console.log(data)
			var html = '<p>联系人: <span style="font-weight:bold;">'+data.user_name+'</span></p>'+
			'<p>联系电话: <span style="font-weight:bold;">'+data.tel+'</span></p>'+
			'<p style="color: #D8241B;">请告知企业,打开“龙泉驿区交通运输发展服务中心”微信公众号,点击“企业入口-排查整改”,开始上传企业整改材料</p>'+
			'<p>如您已经联系企业,请点击<span style="color: #D8241B;font-weight:bold;">“已通知”</span>,系统将记录本次通知</p>';
			this.$alert(html, data.unit_name, {
				dangerouslyUseHTMLString: true,
				confirmButtonText: '已通知',
				cancelButtonText: '取消',
				showCancelButton:true,
			}).then(() => {
				_this.loading = this.$loading({
					lock: true,
					text: "通知发送中...",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.4)",
				});
				//确认修改
				_this.$axios
				.post(_this.$store.state.domain + "/tel_notice", {
					openid: window.localStorage.getItem("openid"),
					id: data.id,
					factory_id: data.factory_id,
				}).then(function(res) {
					_this.loading.close();
					// console.log(res);
					if (res.data.code == "200ok") {
						_this.$message.success(res.data.msg);
						_this.access_record[index].tel_notice = res.data.data;
					} else {
						_this.$message.error(res.data.msg);
					}
				}).catch(function(error) {
					_this.loading.close();
					console.log(error);
					_this.$message.error("网络异常,数据请求失败");
				});
			});
		},
	},
};
</script>
<style>
#app {
	background: #d6dbe2;
}

.el-transfer-panel {
	width: calc(50% - 91px) !important;
	height: 100% !important;
}
.el-transfer {
	height: 100% !important;
}
.el-transfer-panel__body {
	height: 100% !important;
}
.el-transfer-panel__list.is-filterable {
	/* height: 430px !important; */
	height: 100% !important;
}
.el-transfer-panel__list.is-filterable {
	height: calc(100% - 100px) !important;
}

/* .dark .el-input--suffix .el-input__inner {
	background: #000;
    border-color: #ffffff4d;
    color: #fff;
}
.dark .select_factory_box{
	background: #20263B;
}
.dark .fiter{
	border-bottom: 1px solid #454545;
} */

/* 反色 */
html.dark {
	filter: invert(0.92) hue-rotate(180deg);
	transition: 500ms;
}
html.dark button,
html.dark .checked,
html.dark .el-icon-loading,
html.dark .el-loading-text {
	color: #000 !important;
}
/* 图片不反色 */
html.dark img {
	filter: invert(1) hue-rotate(180deg);
}

/* #app {
	background: url(../assets/content_bj.png);
	background-size: 100% 100%;
	overflow: hidden;
} */
.el-drawer__body {
	margin-top: 24px !important;
}
/* ['aria-label'='排查整改'] */
[aria-label='排查整改'] .el-drawer__header{
	margin-bottom: 20px !important;
}
[aria-label='排查整改'] .el-drawer__body{
	margin-top: 0 !important;
}
[aria-label='任务整改'] .el-drawer__header{
	margin-bottom: 20px !important;
}
[aria-label='任务整改'] .el-drawer__body{
	margin-top: 0 !important;
}
[aria-label='任务整改审核'] .el-dialog__body{
	padding: 0 !important;
}


.fenge_line {
	text-align: center;
	font-size: 12px;
	display: flex;
	margin: 20px 0;
}
.fenge_line span {
	display: inline-block;
	padding: 0 10px;
	width: 150px;
}
.fenge_line::after {
	content: "";
	display: inline-block;
	width: 100%;
	height: 1px;
	background: #e6e6e6;
	margin: 10px 0;
}
.fenge_line::before {
	content: "";
	display: inline-block;
	width: 100%;
	height: 1px;
	background: #e6e6e6;
	margin: 10px 0;
}
.examine_btn{
	text-align: center;
	margin-top: 20px;
}
.el-message-box__message p{
	white-space: break-spaces;
}
.el-transfer-panel__filter{
	margin: 10px 15px !important;
}
</style>
